import { RugbyLeagueIncidentId } from '@collector/sportsapi-client-legacy'

import { AddIncidentConfig } from '../../../configuration'

export const addIncidentConfig: AddIncidentConfig<RugbyLeagueIncidentId> = {
  scoreIncidents: [
    RugbyLeagueIncidentId.Try,
    RugbyLeagueIncidentId.DropGoal,
    RugbyLeagueIncidentId.PenaltyTry,
    RugbyLeagueIncidentId.PenaltyKickGoal,
    RugbyLeagueIncidentId.ConversionGoal,
  ],
  missedIncidents: [
    RugbyLeagueIncidentId.DropGoalMissed,
    RugbyLeagueIncidentId.PenaltyKickMissed,
    RugbyLeagueIncidentId.ConversionMissed,
  ],
}
